/* global font injection — one @font-face in the light DOM, accessible from all shadow roots */
if (
  typeof document !== 'undefined' &&
  !document.getElementById('tally-ui-fonts')
) {
  const fontUrl = new URL(
    './assets/fonts/WorkSans-VariableFont_wght.woff2',
    import.meta.url
  ).href
  const style = document.createElement('style')
  style.id = 'tally-ui-fonts'
  style.textContent = `@font-face{font-family:'Work Sans';src:url('${fontUrl}')format('woff2');font-weight:100 900;font-style:normal;font-display:swap}`
  document.head.appendChild(style)
}

/* components */
export { default as TPointsPool } from './components/cc/member/points-pool/points-pool'
export { default as TProcessPoolRedemption } from './components/cc/member/points-pool/process-pool-redemption'
export { default as TLinkAccountDrawer } from './components/cc/member/points-pool/link-account-drawer'
export { default as TRedemption } from './components/cc/member/redemption/redemption'
export { default as TRedemptionForm } from './components/cc/member/redemption/redemption-form'
export { default as TNotes } from './components/app/widgets/notes/notes'
export { default as TIncentiveSummary } from './components/property/incentive-summary/incentive-summary'
export { default as TRegisteredPromotions } from './components/cc/member/promotions/registered-promotions/registered-promotions'
export { default as TManualBonus } from './components/cc/member/manual-bonus/manual-bonus'
export { default as TBroadcastMessagesWidget } from './components/app/widgets/broadcast-messages-widget/broadcast-messages-widget'
export { default as TCallLogs } from './components/app/widgets/call-logs/call-logs'
export { default as TMyTasks } from './components/app/widgets/my-tasks/my-tasks'
export { default as TEligiblePromotions } from './components/cc/member/promotions/eligible-promotions/eligible-promotions'
export { default as TMemberPromotions } from './components/cc/member/promotions/promotions'
export { default as TCommunicationSearch } from './components/cc/misc/communication-search/communication-search'
export { default as TManageCorporateAccounts } from './components/cc/member/corporate-account/corporate-account'
export { default as TAuthorizedMembers } from './components/cc/member/authorized-members/authorized-members'
export { default as TEventRules } from './components/pm/rules/event-rules/event-rules'
export { default as TCreateEditEventRule } from './components/pm/rules/event-rules/create-edit-event-rule'
export { default as TViewEventRule } from './components/pm/rules/event-rules/view-event-rule'
export { default as TManageAce } from './components/pm/custom-data/manage-ace/manage-ace'
export { default as TAudit } from './components/pm/misc/audit/audit'
export { default as TWhrManageIncentives } from './components/pm/misc/whr-manage-incentives/whr-manage-incentives'
export { default as TCommunicationTypes } from './components/pm/misc/communication-types/communication-types'
export { default as TTierHistory } from './components/cc/member/tier-history/tier-history'
export { default as TTestAccountToggle } from './components/cc/member/test-account-toggle/test-account-toggle'
export { default as TMemberSearch } from './components/cc/member/search/search'
export { default as TPropertySystemEarningReport } from './components/reports/property-system-earning-report/property-system-earning-report'
export { default as TBroadcastMessages } from './components/cc/broadcast-messages/broadcast-messages'
export { default as TBroadcastMessageView } from './components/cc/broadcast-messages/broadcast-message-view'
export { default as TLiabilityReport } from './components/reports/liability-report/liability-report'
export { default as TRedemptionReport } from './components/reports/redemption-report/redemption-report'
export { default as TRedemptionRules } from './components/pm/rules/redemption-rules/redemption-rules'
export { default as TCreateEditRedemptionRule } from './components/pm/rules/redemption-rules/create-edit-redemption-rule'
export { default as TSegments } from './components/pm/segments/segments'
export { default as TSegmentsList } from './components/pm/segments/segments-list'
export { default as TSegmentsEdit } from './components/pm/segments/segments-edit'
export { default as TCreateSegment } from './components/pm/segments/create-segment'
export { default as TSegmentMembers } from './components/pm/segments/segment-members'
export { default as TEditSegmentMembers } from './components/pm/segments/edit-segment-members'
export { default as THelpPanel } from './components/app/panel/help-panel/help-panel'
export { default as TMemberMerge } from './components/cc/member/member-merge/member-merge'
export { default as TEarningsReport } from './components/reports/earnings-report/earnings-report'
export { default as TCommunicationHistory } from './components/cc/member/communication-history/communication-history'
export { default as TAsyncTasks } from './components/pm/misc/async-tasks/async-tasks'
export { default as TAlias } from './components/cc/member/alias/alias'
export { default as TTransactionHistory } from './components/cc/member/transaction-history/transaction-history'
export { default as TBadges } from './components/cc/member/badges/badges'
export { default as TLists } from './components/cc/member/lists/lists'
export { default as TEnrollDate } from './components/cc/member/enroll-date/enroll-date'
export { default as TCommunication } from './components/cc/communication/communication'
export { default as TAddAdjustment } from './components/cc/member/add-adjustment/add-adjustment'
export { default as TMemberAlert } from './components/cc/member/alert/alert'
export { default as TReferFriend } from './components/cc/member/refer-friend/refer-friend'
export { default as TWidgetHeader } from './components/app/widgets/widget-header/widget-header'
export { default as TRecentMembers } from './components/app/widgets/recent-members/recent-members'
export { default as TBody } from './components/app/body/body'
export { default as TChatBot } from './components/app/chat-bot/chat-bot'
export { default as TContactUs } from './components/app/contact-us/contact-us'
export { default as TDocs } from './components/docs/dashboard/docs'
export { default as TMemberQuickSearch } from './components/app/widgets/member-quick-search/member-quick-search'
export { default as TShortcuts } from './components/app/widgets/shortcuts/shortcuts'
export { default as TValidEnrollmentSummary } from './components/property/points-bank/valid-enrollment-summary/valid-enrollment-summary'
export { default as TSiteSearch } from './components/app/header/site-search/site-search'
export { default as TPointTransfer } from './components/cc/member/point-transfer/point-transfer'
export { default as TIncentivePointsBank } from './components/property/points-bank/incentive-points-bank/incentive-points-bank'
export { default as TPointsExpiration } from './components/cc/member/points-expiration/points-expiration'
export { default as TIncentiveDetails } from './components/property/incentive-details/incentive-details'
export { default as TPointsSummary } from './components/property/points-bank/points-summary/points-summary'
export { default as TPointsBank } from './components/property/points-bank/points-bank/points-bank'
export { default as TPointsBankTransaction } from './components/property/points-bank/points-bank-transaction/points-bank-transaction'
export { default as TReports } from './components/reports/reports/reports'
export { default as TPointsPackReport } from './components/reports/points-pack-report/points-pack-report'
export { default as TSepFrontDeskReport } from './components/reports/sep-frontdesk-report/sep-frontdesk-report'
export { default as TCompensation } from './components/cc/compensation/compensation'
export { default as TMissingStays } from './components/cc/member/missing-stays/missing-stays'
export { default as TManageAlert } from './components/cc/misc/manage-alerts/manage-alert'
export { default as TContextProvider } from './components/app/context-provider/context-provider'
export { default as TLocaleToggle } from './components/app/header/locale-toggle/locale-toggle'
export { default as TEnrollment } from './components/cc/member/enrollment/enrollment'
export { default as TMemberHeader } from './components/cc/member/header/header'
export { default as TPersonal } from './components/cc/member/personal/personal'
export { default as TPreferences } from './components/cc/member/preferences/preferences'
export { default as TDashboardHeader } from './components/property/dashboard-header/dashboard-header.ts'
export { default as TPropertyDashboard } from './components/property/property-dashboard/property-dashboard'
export { default as TQuarterlyOsat } from './components/property/quarterly-osat/quarterly-osat'
export { default as TEnrollmentPerformance } from './components/property/enrollment-performance/enrollment-performance.ts'
export { default as TEnrollmentTracker } from './components/property/enrollment-tracker/enrollment-tracker.ts'
export { default as TRewardsCircle } from './components/property/rewards-circle/rewards-circle.ts'
export { default as TRetroStay } from './components/cc/transaction/retro-stay/retro-stay'
export { default as TEditTransaction } from './components/cc/transaction/edit-transaction/edit-transaction'
export { default as TExternalLinks } from './components/cc/member/external-links/external-links'
export { default as TSuspendedMembers } from './components/reports/suspended-members/suspended-members'
export { default as TTierPointSummary } from './components/cc/member/tier-point-summary/tier-point-summary'

/* elements */
export { default as TUtilityLinks } from './elements/utility-links/utility-links'
export { default as TPromotionDetails } from './elements/promotion-details/promotion-details'
export { default as TFilter } from './elements/filter/filter'
export { default as TProgressBar } from './elements/progress-bar/progress-bar'
export { default as TMemberResults } from './elements/member-results/member-results'
export { default as TPoolMemberBreakdown } from './elements/pool-member-breakdown/pool-member-breakdown'
export { default as TTable } from './elements/table/table'
export { default as TPicker } from './elements/picker/picker'
export { default as TExpressionBuilder } from './elements/expression-builder/expression-builder'
export { default as TMenuLabel } from './elements/menu-label/menu-label'
export { default as TDivider } from './elements/divider/divider'
export { default as TPopup } from './elements/popup/popup'
export { default as TMenuItem } from './elements/menu-item/menu-item'
export { default as TMenu } from './elements/menu/menu'
export { default as TDropdown } from './elements/dropdown/dropdown'
export { default as TFormattedDateInput } from './elements/formatted-date-input/formatted-date-input'
export { default as TSearchForm } from './elements/search-form/search-form'
export { default as TGrid } from './elements/grid/grid'
export { default as TStorybookRenderer } from './elements/storybook-renderer/storybook-renderer'
export { default as TRecordModified } from './elements/record-modified/record-modified'
export { default as TWidget } from './elements/widget/widget'
export { default as TDrawer } from './elements/drawer/drawer'
export { default as TPill } from './elements/pill/pill'
export { default as TQuickSearch } from './elements/quick-search/quick-search'
export { default as TAlert } from './elements/alert/alert'
export { default as TAccessGuard } from './elements/access-guard/access-guard'
export { default as TBaseElement } from './elements/base-element/base-element'
export { default as TButton } from './elements/button/button'
export { default as TButtonGroup } from './elements/button-group/button-group'
export { default as TCard } from './elements/card/card'
export {
  TCardLayout,
  TCardHeader,
  TCardTitle,
  TCardDescription,
  TCardContent,
  TCardFooter,
  TCardSkeleton,
  TStatCards,
  TProgramRuleCard,
  TCardSearch,
  TDocLinkCard,
} from './elements/card-layout/card-layout'
export { default as TCheckbox } from './elements/checkbox/checkbox'
export { default as TDialog } from './elements/dialog/dialog'
export { default as TFieldset } from './elements/fieldset/fieldset'
export { default as TForm } from './elements/form/form'
export { default as TFormFooter } from './elements/form-footer/form-footer'
export { default as THelpText } from './elements/help-text/help-text'
export { default as TAvatar } from './elements/avatar/avatar'
export { default as TIcon } from './elements/icon/icon'
export { default as TIconBadge } from './elements/icon/icon-badge'
export { default as TInput } from './elements/input/input'
export { default as TRadio } from './elements/radio/radio'
export { default as TSelect } from './elements/select/select'
export { default as TDynamicChoice } from './elements/dynamic-choice/dynamic-choice'
export { default as TTabs } from './elements/tabs/tabs'
export { default as TTextarea } from './elements/textarea/textarea'
export { default as TTypeahead } from './elements/typeahead/typeahead'
export { default as TView } from './elements/view/view'
export { default as TFileDropBox } from './elements/file-dropbox/file-dropbox'
export { default as TPhoneIntl } from './elements/phone-intl/phone-intl'
export { default as TPageLayout } from './elements/page-layout/page-layout'
export {
  TPageHeader,
  TPageTitle,
  TPageDescription,
  TPageToolbar,
  TPageBody,
} from './elements/page-layout/page-header'
export { default as TPanelHeader } from './elements/panel-header/panel-header'
export { default as TToggleRow } from './elements/toggle-row/toggle-row'
export { default as TSectionHeader } from './elements/section-header/section-header'
export { default as TStepper } from './elements/stepper/stepper'
export { default as TStep } from './elements/step/step'
export { default as TSkeleton } from './elements/skeleton/skeleton'
export { default as TStatus } from './elements/status/status'
export { default as TEmptyState } from './elements/empty-state/empty-state'
export { default as TPopover } from './elements/popover/popover'
export { default as TResourceLink } from './elements/resource-link/resource-link'

import './tally-ui-dynamic.js'
